import SimpleImageViewer from './Components/SimpleImageViewer';
export { SimpleImageViewer };
